import { a as __extends, b as __awaiter, e as __generator, g as __spread, C as ClientSDKProxyContext, d as __assign, _ as __makeTemplateObject } from '../../chunks/chunk-525a49bc.js';
import { Tree } from 'antd';
import React, { Component } from 'react';
import styled from 'styled-components';
import { E as ERROR_NO_SDK_CLIENT } from '../../chunks/chunk-bc685b06.js';
import '../../chunks/chunk-53391a7d.js';
import '../../chunks/chunk-c2b06a8e.js';
import '../../chunks/chunk-6cec2b98.js';
import { d as defaultTheme, w as withDefaultTheme } from '../../chunks/chunk-2f6aabaf.js';
import '../../chunks/chunk-e1ac37a6.js';
import { a as applyThemeFontFamily, b as applyThemeFontSize, c as applyThemeListHighlight } from '../../chunks/chunk-ae1accbb.js';

// TODO GENERAL
var TreeNode = Tree.TreeNode;
var ThreeDNodeTree = /** @class */ (function (_super) {
    __extends(ThreeDNodeTree, _super);
    function ThreeDNodeTree(props) {
        var _this = _super.call(this, props) || this;
        _this.onLoadData = function (treeNode) { return __awaiter(_this, void 0, void 0, function () {
            var eventKey, threeDnodeId, query, loadedData_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (treeNode.props.children) {
                            return [2 /*return*/];
                        }
                        eventKey = treeNode.props.eventKey;
                        threeDnodeId = eventKey ? Number.parseInt(eventKey, 10) : undefined;
                        if (!(threeDnodeId && !Number.isNaN(threeDnodeId))) return [3 /*break*/, 2];
                        query = {
                            depth: 2,
                            nodeId: threeDnodeId,
                        };
                        return [4 /*yield*/, this.cursorApiRequest(this.state.modelId, this.state.revisionId, query)];
                    case 1:
                        loadedData_1 = _a.sent();
                        if (loadedData_1.length > 1) {
                            treeNode.props.dataRef.children = loadedData_1
                                .slice(1)
                                // @ts-ignore
                                .sort(function (a, b) { return a.name.localeCompare(b.name); })
                                .filter(function (x) { return x.parentId && x.parentId === treeNode.props.dataRef.key; })
                                .map(function (x) {
                                if (loadedData_1.filter(function (y) { return y.parentId === x.id; }).length <= 0) {
                                    _this.state.loadedKeys.push("" + x.id);
                                    return {
                                        title: "" + x.name,
                                        key: x.id,
                                        node: x,
                                        isLeaf: true,
                                    };
                                }
                                else {
                                    return {
                                        title: "" + x.name,
                                        key: x.id,
                                        node: x,
                                        isLeaf: false,
                                    };
                                }
                            });
                            this.setState({
                                loadedKeys: __spread(this.state.loadedKeys),
                                treeData: __spread(this.state.treeData),
                            });
                        }
                        else {
                            treeNode.props.dataRef.isLeaf = true;
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        _this.onSelectNode = function (returnNode) {
            var onSelect = _this.props.onSelect;
            if (onSelect) {
                onSelect(returnNode);
            }
        };
        _this.onRightClickNode = function (event) {
            var onRightClick = _this.props.onRightClick;
            if (onRightClick) {
                onRightClick(event);
            }
        };
        _this.onExpand = function (expandedKeys) {
            _this.setState({
                expandedKeys: ThreeDNodeTree.toKeys(expandedKeys.map(function (key) { return Number.parseInt(key, 10); })),
            });
        };
        _this.renderTreeNode = function (nodes) {
            var styles = _this.props.styles;
            return nodes.map(function (item) {
                if (item.children) {
                    return (React.createElement(TreeNodeWrapper, { title: item.title, key: item.key, dataRef: item, style: styles && styles.list }, _this.renderTreeNode(item.children)));
                }
                return (React.createElement(TreeNodeWrapper, { title: item.title, key: item.key, dataRef: item, style: styles && styles.list }));
            });
        };
        _this.cursorApiRequest = function (modelId, revisionId, params, data) {
            if (data === void 0) { data = []; }
            return __awaiter(_this, void 0, void 0, function () {
                var result, cursor;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.client.viewer3D.listRevealNodes3D(modelId, revisionId, params)];
                        case 1:
                            result = _a.sent();
                            cursor = result.nextCursor;
                            if (result.nextCursor) {
                                return [2 /*return*/, this.cursorApiRequest(modelId, revisionId, __assign(__assign({}, params), { cursor: cursor }), __spread(data, result.items))];
                            }
                            return [2 /*return*/, __spread(data, result.items)];
                    }
                });
            });
        };
        var defaultExpandedKeys = props.defaultExpandedKeys;
        _this.state = {
            threeDNodes: [],
            treeData: [],
            expandedKeys: defaultExpandedKeys
                ? ThreeDNodeTree.toKeys(defaultExpandedKeys)
                : {},
            modelId: props.modelId,
            revisionId: props.revisionId,
            loadedKeys: [],
        };
        return _this;
    }
    ThreeDNodeTree.returnPretty = function (threeDNode) {
        return {
            title: "" + threeDNode.name,
            key: threeDNode.id,
            node: threeDNode,
            isLeaf: threeDNode.subtreeSize === 1,
        };
    };
    ThreeDNodeTree.toKeys = function (path, initial) {
        if (initial === void 0) { initial = {}; }
        return path.reduce(function (acc, i) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[i] = true, _a)));
        }, initial);
    };
    ThreeDNodeTree.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var threeDNodes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.client = this.context(ThreeDNodeTreeWithTheme.displayName || '');
                        if (!this.client) {
                            console.error(ERROR_NO_SDK_CLIENT);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.client.viewer3D.listRevealNodes3D(this.state.modelId, this.state.revisionId, { depth: 1 })];
                    case 1:
                        threeDNodes = _a.sent();
                        this.setState({
                            threeDNodes: threeDNodes.items,
                            treeData: threeDNodes && threeDNodes.items.length > 0
                                ? this.mapDataNodes(threeDNodes.items)
                                : [],
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ThreeDNodeTree.prototype.mapDataNodes = function (threeDNodes) {
        var _this = this;
        var nodes = {};
        threeDNodes.forEach(function (threeDNode) {
            if (threeDNode.depth === 0) {
                nodes[threeDNode.id] = ThreeDNodeTree.returnPretty(threeDNode);
            }
        });
        threeDNodes.forEach(function (threeDNode) {
            var parentId = threeDNode.parentId;
            var node = nodes[parentId]; // casting is not a problem. It will return undefined if not found
            if (!node) {
                return;
            }
        });
        return Object.keys(nodes).map(function (id) {
            if (nodes[id].isLeaf) {
                _this.state.loadedKeys.push("" + id);
            }
            _this.setState({
                loadedKeys: __spread(_this.state.loadedKeys),
            });
            return nodes[id];
        });
    };
    ThreeDNodeTree.prototype.render = function () {
        var _this = this;
        var _a = this.state, treeData = _a.treeData, expandedKeys = _a.expandedKeys;
        return (React.createElement(Tree, { loadData: this.onLoadData, onSelect: function (_, e) { return _this.onSelectNode(e.node.props.dataRef); }, expandedKeys: Object.keys(expandedKeys), onExpand: this.onExpand, loadedKeys: this.state.loadedKeys, onRightClick: this.onRightClickNode }, this.renderTreeNode(treeData)));
    };
    ThreeDNodeTree.contextType = ClientSDKProxyContext;
    ThreeDNodeTree.defaultProps = {
        modelId: 0,
        revisionId: 0,
        onSelect: function (selectedNode) {
            return selectedNode.key;
        },
        theme: __assign({}, defaultTheme),
    };
    return ThreeDNodeTree;
}(Component));
var TreeNodeWrapper = styled(TreeNode)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  & span {\n    color: ", ";\n  }\n  & .ant-tree-node-selected {\n    ", "\n  }\n"], ["\n  ", "\n  ", "\n  & span {\n    color: ", ";\n  }\n  & .ant-tree-node-selected {\n    ", "\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return applyThemeFontFamily(theme.gearbox);
}, function (_a) {
    var theme = _a.theme;
    return applyThemeFontSize(theme.gearbox);
}, function (_a) {
    var theme = _a.theme;
    return theme.gearbox.textColor;
}, function (_a) {
    var theme = _a.theme;
    return applyThemeListHighlight(theme.gearbox);
});
var ThreeDNodeTreeWithTheme = withDefaultTheme(ThreeDNodeTree);
ThreeDNodeTreeWithTheme.displayName = 'ThreeDNodeTree';
var templateObject_1;

export { ThreeDNodeTreeWithTheme as ThreeDNodeTree };
